



































import Vue from 'vue'
import {
  DxGantt,
  DxColumn,
  DxDependencies,
  DxResourceAssignments,
  DxResources,
  DxTasks, DxFilterRow
} from 'devextreme-vue/gantt'
import 'devexpress-gantt/dist/dx-gantt.min.css'
import 'devexpress-gantt/dist/dx-gantt.min'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

interface ComponentData {
  taskList: any[]
  dependencies: any[]
  resources: any[]
  resourceAssignments: any[]

  startDateRange: Date
  endDateRange: Date
}

export default Vue.extend({
  name: 'ProjectProcessGantt',

  components: {
    DxGantt,
    DxTasks,
    DxDependencies,
    DxResources,
    DxResourceAssignments,
    DxColumn,
    DxFilterRow
  },

  props: {
    ganttHeight: String
  },

  data (): ComponentData {
    return {
      taskList: [],
      dependencies: [],
      resources: [],
      resourceAssignments: [],

      startDateRange: moment('2023-02-01').startOf('day').toDate(),
      endDateRange: moment('2023-02-28').endOf('day').toDate(),
    }
  },

  watch: {

  },

  computed: {
    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    formatDate(item: string): string {
      return moment(item).isValid() ? moment(item).format('DD.MM.YYYY') : ''
    },
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted () {
    this.taskList = [{
        id: 1,
        parentId: 0,
        title: 'Group1',
        start: new Date('2023-02-21T05:00:00.000Z'),
        end: new Date('2023-02-22T10:00:00.000Z'),
        progress: 31,
      },
      {
        id: 2,
        parentId: 1,
        title: 'Test1',
        start: new Date('2023-02-21T05:00:00.000Z'),
        end: new Date('2023-02-26T09:00:00.000Z'),
        progress: 60,
      },
      {
        id: 3,
        parentId: 0,
        title: 'Group2',
        start: new Date('2023-02-21T05:00:00.000Z'),
        end: new Date('2023-02-21T09:00:00.000Z'),
        progress: 100,
      },
      {
        id: 4,
        parentId: 3,
        title: 'Test2',
        start: new Date('2023-02-21T10:00:00.000Z'),
        end: new Date('2023-02-22T09:00:00.000Z'),
        progress: 100,
      },
      {
        id: 5,
        parentId: 3,
        title: 'Test3',
        start: new Date('2023-02-22T10:00:00.000Z'),
        end: new Date('2023-02-25T09:00:00.000Z'),
        progress: 60,
      },
      {
        id: 6,
        parentId: 0,
        title: 'Group3',
        start: new Date('2023-02-22T10:00:00.000Z'),
        end: new Date('2023-02-25T09:00:00.000Z'),
        progress: 60,
      },
      {
        id: 7,
        parentId: 0,
        title: 'Group4',
        start: new Date('2023-02-22T10:00:00.000Z'),
        end: new Date('2023-02-25T09:00:00.000Z'),
        progress: 60,
      },
      {
        id: 8,
        parentId: 0,
        title: 'Group5',
        start: new Date('2023-02-22T10:00:00.000Z'),
        end: new Date('2023-02-25T09:00:00.000Z'),
        progress: 60,
      },
    ]

    this.dependencies = [{
        id: 1,
        predecessorId: 1,
        successorId: 2,
        type: 0,
      }, {
        id: 2,
        predecessorId: 3,
        successorId: 5,
        type: 0,
      },
    ]

    this.resources = [{
        id: 1,
        text: 'AAA',
      }, {
        id: 2,
        text: 'BBB',
      },
    ]

    this.resourceAssignments = [{
        id: 0,
        taskId: 1,
        resourceId: 1,
      }, {
        id: 1,
        taskId: 2,
        resourceId: 1,
      }, {
        id: 2,
        taskId: 3,
        resourceId: 2,
      }, {
        id: 3,
        taskId: 4,
        resourceId: 2,
      }, {
        id: 4,
        taskId: 5,
        resourceId: 2,
      }
    ]
  }
})
